<div id="popup">
    <div class="title-head index-head" fxLayout="row" fxLayoutAlign="space-between center">
        <span style="color: white;">
            Confirm Status Change
        </span>
        <button [attr.guide]="'confirm-dialog-btn-1' + '__' + sanitizedUrl" mat-icon-button>
            <mat-icon (click)="close()">
                close
            </mat-icon>
        </button>
    </div>

    <mat-dialog-content [ngStyle.lt-md]="'max-height: 100%'" style=" MARGIN: 0PX; padding: 0px;">
        <div class="padding-11">
            <div fxLayout="column" [formGroup]="confirmForm">

                <div *ngIf="data.isLost" fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">


                    <mat-form-field  fxFlex appearance="outline">
                        <mat-label>Reason For Loss</mat-label>
                        <mat-select formControlName="reason">

                            <mat-option>
                                <ngx-mat-select-search name="'Reason For Loss'" ngDefaultControl
                                    [formControl]="dealsCloseReasonFilterControl" placeholderLabel="Search"
                                    [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                                </ngx-mat-select-search>
                            </mat-option>
                            <mat-option (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId)"
                                *ngFor="let opt of filteredDealsCloseReasonTypeList" [value]="opt.statusId">
                                {{opt.statusName}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="confirmForm.controls['reason'].touched && confirmForm.controls['reason'].hasError('required')">please fill out this filed</mat-error>
                    </mat-form-field>


                    <!-- <mat-form-field appearance="outline" fxFlex>
                        <mat-label>Lost Reason</mat-label>
                        <textarea [attr.guide]="'confirm-dialog-sel-2' + '__' + sanitizedUrl" trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5 matInput
                            [(ngModel)]="reason" matInput required>
                </textarea>

                    </mat-form-field> -->

                </div>

                 <div  fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
                    <mat-form-field appearance="outline" fxFlex>
                        <mat-label>Description</mat-label>
                        <textarea [attr.guide]="'confirm-dialog-sel-3' + '__' + sanitizedUrl" trim="blur" matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5 matInput
                            formControlName="description" matInput>
                </textarea>
                <mat-error *ngIf="confirmForm.controls['description'].touched && confirmForm.controls['description'].hasError('required')">please fill out this filed</mat-error>


                    </mat-form-field>
                    </div>

                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
                    <p class="padding-10">Move deal to <b>{{data.newStatus}}</b>?</p>
                </div>

                <div class="padding-top10" fxLayoutAlign="end center" fxLayoutGap="10px">

                    <button [attr.guide]="'confirm-dialog-btn-4' + '__' + sanitizedUrl" type="button" mat-raised-button (click)="close()">Cancel
                    </button>

                    <button [attr.guide]="'confirm-dialog-btn-5' + '__' + sanitizedUrl" mat-raised-button color="primary"
                        (click)="confirm()">Confirm</button>


                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>